import { ItemId, TreeData } from '@atlaskit/tree'

export const getMenuPointOrderFromTree = (
  tree: TreeData,
  treeItemId: ItemId,
  treeItemParentId?: ItemId
): number => {
  const parentId = treeItemParentId || tree.rootId
  const index = tree.items[parentId]?.children.findIndex(value => value === treeItemId) ?? -1

  return index >= 0 ? index : 0
}
